module.exports = __webpack_public_path__ + "static/Sonepar-74770700dbf0025b504a4820daf1a755.jpg";